import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryApi, BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import * as Sentry from "@sentry/react";

export const BASE_APP_URL =
  window.location.hostname === import.meta.env.VITE_APP_PLATE_HOSTNAME
    ? `/api/`
    : `${import.meta.env.VITE_APP_PLATE_URL}/api/`;

function injectToken(
  headers: Headers,
  api: Pick<BaseQueryApi, "getState" | "extra" | "endpoint" | "type" | "forced">
): Headers {
  const token = localStorage.getItem("accessToken");
  if (!token) return headers;
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
}

export const rawBaseAppQuery = fetchBaseQuery({
  baseUrl: BASE_APP_URL,
  prepareHeaders: (headers, api) => {
    headers = injectToken(headers, api);
    headers.set("Accept-Language", "ru");
    return headers;
  },
});

function withSentry(
  rawQuery: ReturnType<typeof fetchBaseQuery>
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  return async (args, api, extraOptions) => {
    const result = await rawQuery(args, api, extraOptions);
  
    if (result.error) {
      Sentry.captureException(new Error(`API Error: ${api.endpoint}`), {
        tags: {
          endpoint: api.endpoint,
          status: result.error.status,
        },
        extra: {
          url: typeof args === "string" ? args : args.url,
          method: typeof args === "string" ? "GET" : args.method,
          requestBody: typeof args === "string" ? undefined : args.body,
          errorData: result.error.data,
        },
      });
    }

    return result;
  };
}

export const baseAppQuery = withSentry(rawBaseAppQuery);

export const baseAuthQuery = withSentry(fetchBaseQuery({ baseUrl: BASE_APP_URL }));